import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, useParams } from 'react-router'
import OrganizationIntegrations from 'src/app/OrganizationIntegrations/OrganizationIntegrations'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import {
  orgAccountingIntegrationsRouteProps,
  OrgIntegrationsMatchParams,
  orgIntegrationsRouteProps,
  orgProductivityIntegrationsRouteProps,
} from 'src/navigation/routeProps'
import { organizationAccountingIntegrationsUrl } from 'src/navigation/urls'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { isGoogleWorkspaceIntegrationsEnabled } from 'src/utils/featureFlags'

const AccountingIntegrationsRedirect: React.FC = () => {
  const { id } = useParams<OrgIntegrationsMatchParams>()
  return <Redirect to={organizationAccountingIntegrationsUrl(id)} />
}

const ProductivityIntegrationsPage: React.FC = () => {
  const { id } = useParams<OrgIntegrationsMatchParams>()
  const remoteConfig = useSelector(selectFeatureFlaggerFromState)

  return isGoogleWorkspaceIntegrationsEnabled(remoteConfig) ? (
    <OrganizationIntegrations category="productivity" />
  ) : (
    <Redirect to={organizationAccountingIntegrationsUrl(id)} />
  )
}

export const OrganizationIntegrationsAccountingAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsIntegrationsAccounting,
  routeProps: orgAccountingIntegrationsRouteProps,
  component: <OrganizationIntegrations category="accounting" />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export const OrganizationIntegrationsProductivityAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsIntegrationsProductivity,
  routeProps: orgProductivityIntegrationsRouteProps,
  component: <ProductivityIntegrationsPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

const OrganizationIntegrationsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsIntegrations,
  routeProps: orgIntegrationsRouteProps,
  component: <AccountingIntegrationsRedirect />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default OrganizationIntegrationsAppRoute
